import React from 'react';
import { Box } from '@mui/material';
import FilterChip from './FilterChip';
import {
  ASSIGNMENT_BADGES,
  getBadgeColor,
  getBadgeTextColor,
  getBadgeBorderColor
} from '../../../constants/assignmentStatuses';

/**
 * ADR-014 §10m — "the session ended while this assignment was still open".
 *
 * A boolean facet, NOT a sixth chip in the assignment-status row. "Left
 * incomplete" is a freeze crossed with whatever stage the work had reached, so
 * it does not partition that row the way Completed/Closed partitions the
 * session row: ticking `In Progress` + `Left Incomplete` would give
 * (live in progress) union (frozen at any stage), which is not "everything that
 * reached In Progress". Kept separate, the two compose instead —
 * `In Progress` + this toggle = frozen mid-review.
 *
 * Palette is the frozen badge's own slate, so the control and the card badge it
 * selects for read as the same thing.
 */
const LeftIncompleteFilter = ({
  isSelected = false,
  onToggle,
  label = 'Left Incomplete Only',
  sx = {}
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', ...sx }}>
      <FilterChip
        label={label}
        isSelected={isSelected}
        onClick={onToggle}
        backgroundColor={getBadgeColor(ASSIGNMENT_BADGES.LEFT_INCOMPLETE)}
        textColor={getBadgeTextColor(ASSIGNMENT_BADGES.LEFT_INCOMPLETE)}
        borderColor={getBadgeBorderColor(ASSIGNMENT_BADGES.LEFT_INCOMPLETE)}
        showDot={true}
      />
    </Box>
  );
};

export default LeftIncompleteFilter;
